var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnsure = function SvgUnsure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.245 15.161v-.236q.01-1.646.31-2.619.308-.973.872-1.563a6.7 6.7 0 0 1 1.373-1.1q.555-.345.99-.755.445-.418.7-.927.255-.517.255-1.155 0-.718-.336-1.245a2.3 2.3 0 0 0-.91-.818 2.7 2.7 0 0 0-1.263-.291q-.646 0-1.227.282-.573.273-.955.836-.373.555-.418 1.41H10.4q.045-1.728.836-2.892a4.95 4.95 0 0 1 2.11-1.745q1.318-.582 2.908-.582 1.737 0 3.055.61 1.326.608 2.063 1.735.746 1.118.746 2.655 0 1.036-.337 1.855a4.5 4.5 0 0 1-.936 1.454 6.9 6.9 0 0 1-1.445 1.136 6.2 6.2 0 0 0-1.21.946q-.464.49-.69 1.154-.219.655-.228 1.619v.236z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.6 8.161h7.6v3.2H4.8v11.2h10.589l.61 1.222.612-1.222H27.2v-11.2h-2.8v-3.2h6v17.6H18.589l-2.59 5.178-2.588-5.178H1.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.6 20.161v-3.2h-3.2v3.2z"
  })));
};
export default SvgUnsure;